import { render, staticRenderFns } from "./onetimePass.vue?vue&type=template&id=82c3138e&"
import script from "./onetimePass.vue?vue&type=script&lang=ts&"
export * from "./onetimePass.vue?vue&type=script&lang=ts&"
import style0 from "./onetimePass.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports